<template>
  <IconLucideImageDown />
</template>
